import React, { useContext, useEffect, useState } from 'react';
import './RecipeActionButton.css';
import { SocketContext } from '../SocketContext';
import InputContext from './InputContext';

const baseURL = process.env.REACT_APP_API_URL;

function LikeButton({ recipeId, initialCount = 0, likedUsers = [] }) {
    const { username } = useContext(InputContext);
    const socket = useContext(SocketContext);
    const [liked, setLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(initialCount);

    useEffect(() => {
        if (likedUsers.includes(username)) {
            setLiked(true);
        }
    }, [username, likedUsers]);

    useEffect(() => {
        if (!socket) return;
        const handleLikeUpdate = (data) => {
            console.log('Received likeUpdated:', data);
            if (data.id === recipeId) {
                setLikeCount(data.likes);
            }
        };

        socket.on('likeUpdated', handleLikeUpdate);
        return () => socket.off('likeUpdated', handleLikeUpdate);
    }, [socket, recipeId]);

    const handleLike = async () => {
        try {
            const res = await fetch(`${baseURL}/recipes/${recipeId}/like`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username })
            });

            const data = await res.json();
            setLiked(data.liked);
            setLikeCount(data.likes);
        } catch (err) {
            console.error('Like toggle failed:', err);
        }
    };

    return (
        <button
            className={`recipe-button ${liked ? 'liked' : ''}`}
            onClick={handleLike}
        >
            {liked ? '❤️' : '🤍'} {likeCount} {likeCount === 1 ? 'Like' : 'Likes'}
        </button>
    );
}

export default LikeButton;
